import { BaseError, createErrorBuilder } from './BaseError';

export enum EditorPlatformInternalErrorCode {
  UnexpectedError = 'UnexpectedError',
}

class EditorPlatformInternalError extends BaseError<EditorPlatformInternalErrorCode> {
  state: Partial<{
    host: string;
  }> = {};

  constructor(message: string, code: EditorPlatformInternalErrorCode) {
    super(message, code, 'Editor Platform Internal Error');
  }

  withHost(host: string) {
    this.state = { ...this.state, host };
    return this;
  }
}

export const createEditorPlatformInternalError = createErrorBuilder<
  EditorPlatformInternalErrorCode,
  EditorPlatformInternalError
>(EditorPlatformInternalError);
